import styled from 'styled-components';
import { getGradientTextStyles } from './gradientTextStyles';

// We don't want to use the opacity prop to hide the editor, because it will affect the selection
// and cursor visibility. Instead, we make all the text transparent.
const RichTextEditorWrapper = styled.div`
  .st-materialized-font-size-block {
    font-size: 0;
    line-height: 0;
  }

  .st-materialized-font-size-block span[data-offset-key] {
    line-height: ${({ $materializedLineHeight }) => $materializedLineHeight};
  }

  ${({ $gradientFill }) =>
    getGradientTextStyles($gradientFill, {
      includeCaretColor: true,
      backgroundSize: 'var(--text-gradient-width) var(--text-gradient-height)',
      backgroundPosition:
        'var(--text-gradient-offset-x) var(--text-gradient-offset-y)',
    })}

  ${({ isVisible }) =>
    !isVisible &&
    `
      * {
        color: transparent !important;
        -webkit-text-fill-color: transparent !important;
        background-image: none !important;
        background-clip: border-box !important;
        -webkit-background-clip: border-box !important;
      }
      li::before {
        /* Shape markers paint backgrounds and borders, not just text. */
        opacity: 0 !important;
        color: transparent !important;
        -webkit-text-fill-color: transparent !important;
      }
    `};
`;

export default RichTextEditorWrapper;
